<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          :fixWidth="300"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 1, text: '发货单号'},
              {id: 2, text: '调拨单号'},
              {id: 3, text: '货件号'},
            ]"
        ></gj-select-input>
        <gj-select
            v-model="filter.status"
            :options="option.shipmentBillOption"
            placeholder="全部状态"
        ></gj-select>
        <gj-country-select
            v-model="filter.shipCountryCode"
            placeholder="发货国"
            multiple
        ></gj-country-select>

        <gj-select
            v-model="filter.transportId"
            placeholder="物流方式"
            :options="option.transportOption"
        ></gj-select>
        <gj-market-select
            v-model="filter.marketIds"
            multiple
            width="150px"
        ></gj-market-select>
        <gj-select-input
                :options="[
              {id: 1, text: 'MSKU'},
              {id: 2, text: 'FNSKU'},
              {id: 3, text: 'SKU'},
              {id: 4, text: '产品名称'},
              {id: 5, text: 'ASIN'},
              {id: 6, text: '物流跟踪号'},
            ]"
                v-model="filter.keyword1"
                :width="['100px', '120px']"
        ></gj-select-input>
        <gj-select-date-picker
                :options="[
              {id: 1, text: '预计出运日期'},
              {id: 2, text: '实际出运日期'},
              {id: 3, text: '预计签收日期'},
              {id: 4, text: '实际签收日期'},
              {id: 5, text: '创建时间'},
            ]"
                :width="['120px']"
                type="daterange"
                v-model="filter.keyword2"
        ></gj-select-date-picker>
        <template #advancedFilter>
          <gj-country-select
                  v-model="filter.arrivalCountryCode"
                  placeholder="目的国"
                  style="width: 120px"
                  multiple
          ></gj-country-select>
          <gj-warehouse-select
                  v-model="filter.warehouseIds"
                  placeholder="目的仓"
                  multiple
                  style="width: 180px"
          ></gj-warehouse-select>
        </template>
        <template #right>
          <gj-tool-group
              :download="$permission('shipNote:export')"
              :download-params="globalParams"
              download-url="/supply/shipNote/export"
              help
          ></gj-tool-group>
          <view-setting
                  :ref="REF_VIEW_SETTING"
                  save-mode="remote"
                  :use-default="true"
                  :module-name="moduleName"
                  :config="model"
                  :fn-generate-params="generateViewParams"
                  @view-change="handleChangeView"
                  @view-complete="handCompleteView"
          >
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :scroll-x="{gt: -1}"
          :scroll-y="{gt: -1}"
          :show-overflow="false"
          :extend-row-config="{prop: 'extendRow'}"
          :structure-config="{type: 'ParentChild', children: 'noteItemList', parentSpan: [0, 12]}"
          sortable="custom"
          :pagination="pagination"
          :default-sort="{prop: 'createTime', order: 'descending'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:warehouse="{row}">
          <template v-if="row.$gjParentData">
            <span style="display: inline-block; width: 148px;">
              {{row.code}}
              <gj-copy-icon :content="row.code"></gj-copy-icon>
            </span>
            <span v-gutter="20">
              <span>{{row.shipCountryCode}}→{{row.arrivalCountryCode}}</span>
              <span>{{row.transportName}}</span>
              <span>
                <gj-tag
                    type="plain"
                    shape="rectangle"
                    :color="row.status | optionColor(option.shipmentBillOption)">
                  {{ row.status | optionText(option.shipmentBillOption) }}
                </gj-tag>
              </span>
              <template v-for="(item, index) in row.logisticsFeeList">
                <span :key="index">
                  <span class="label-color">{{item.feeTypeName}}：</span>
                  {{item.currencySymbol}}{{item.fee | number}}
                </span>
              </template>
              <span>
              <span class="label-color">备注：</span>
                <gj-text :content="row.memo" max-width="120px">{{row.memo | defaultShow}}</gj-text>
              </span>
              <span>
              <span class="label-color">发货量：</span>
                {{row.shipQuantity}}
              </span>
              <span>
              <span class="label-color">收货量：</span>
                {{row.receiptQuantity}}
              </span>
              <span>
              <span class="label-color">收发差异：</span>
                {{Number(row.receiptQuantity || 0) - Number(row.shipQuantity || 0)}}
              </span>
              <span>
              <span class="label-color">物流跟踪号：</span>
                {{row.trackings | defaultShow}}
              </span>
              <span>
              <span class="label-color">预计出运日期：</span>
                {{row.expectShipDate | defaultShow}}
              </span>
              <span>
              <span class="label-color">实际出运日期：</span>
                {{row.actualShipDate | defaultShow}}
              </span>
            </span>
          </template>
          <template v-else>
            {{row.warehouseName | defaultShow}}
          </template>
        </template>
        <template v-slot:productInfo="{row}">
          <div><gj-text :content="row.productName" width="150px">{{row.productName}}</gj-text></div>
          <div><gj-text :content="row.sku">{{row.sku}}</gj-text></div>
          <div>{{row.categoryName	}}</div>
        </template>
        <template v-slot:msku="{row}">
          <div><gj-text :content="row.msku" width="100%">{{row.msku}}</gj-text></div>
          <div>{{row.fnsku}}</div>
          <div>{{row.asin}}</div>
        </template>
        <template v-slot:difference="{row}">
          {{Number(row.receiptQuantity || 0) - Number(row.shipQuantity || 0)}}
        </template>
        <template v-slot:op="{ index, row }">
          <template v-if="row.$gjParentData">
            <gj-button-group
                type="dropdown-op"
                :config="opBtnConfig(row)"
            ></gj-button-group>
          </template>
        </template>
        <template v-slot:extend:row="{row}">
          <div class="default">
            <div v-if="!row.expand">
              <gj-link type="default" @click="openDetailRows(row,true)">
                更多（共{{row.num}}条）
                <i class="iconfont iconzhankai"></i>
              </gj-link>
            </div>
            <div v-else>
              <gj-link type="default" @click="openDetailRows(row, false)">
                收起
                <i class="iconfont iconshouqi"></i>
              </gj-link>
            </div>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {queryMixin, responseMixin} from "../../../../minxins";
  import {shipmentBillEnum, shipmentBillOption} from "./enum";
  import AppShipmentBillDetail from './modal/shipment-bill-detail';
  import AppShipmentBillGenerate from '../../common/logistics/shipment-bill/shipment-bill-generate';
  import {getShipNotePage, getTransportSelect, shipNoteAbolished, shipNoteFinish} from "../../../../api/logistics";
  import {isMeaningful, transformToMap} from "@/utils/common";
  import {convertToDate, generateViewParams} from "@/utils/date.util";
  import {countryOption} from "@/utils/options";
  import {logOpType} from "../../warehouse/inventory/enum";
  import {mapGetters} from "vuex";
  import model from './viewConfig'

  export default {
    name: "shipment-bill",
    mixins: [queryMixin, responseMixin],
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    watch: {
      'option.transportOption': {
        handler(val) {
          this.model = model.bind(null, val)
        }
      }
    },
    created() {
      getTransportSelect()
        .then((data) => {
          this.option.transportOption = data.map(v => {return {id: v.id, text: v.name}})
        })
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'warehouse', header: '目的仓', field: 'slot:warehouse', width: '135px'},
          {id: 'warehouseCode', header: '亚马逊仓库代码', field: 'sku', minWidth: '120px'},
          {id: 'picture', header: '图片', field: 'picture:smallImageUrl', minWidth: '50px'},
          {id: 'marketId', header: '国家/店铺', field: 'option:marketId', minWidth: '120px', options: () => this.marketOption},
          {id: 'productInfo', header: '产品名称/SKU/产品类型-品类', field: 'slot:productInfo', minWidth: '190px'},
          {id: 'msku', header: 'MSKU/FNSKU/ASIN', field: 'slot:msku', minWidth: '160px'},
          {id: 'shipmentId', header: '货件号', field: 'shipmentId', minWidth: '120px'},
          {id: 'relevanceCode', header: '调拨单号', field: 'relevanceCode', minWidth: '135px'},
          {id: 'shipQuantity', header: '发货量', field: 'shipQuantity', minWidth: '80px'},
          {id: 'receiptQuantity', header: '收货量', field: 'receiptQuantity', minWidth: '80px'},
          {id: 'difference', header: '收发差异', field: 'slot:difference', minWidth: '100px'},
          {id: 'expectSignDate', header: '预计签收日期', field: 'expectSignDate', minWidth: '120px'},
          {id: 'actualSignDate', header: '实际签收日期', field: 'actualSignDate', minWidth: '120px'},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '120px', fixed: 'right'},
        ],
        filter: {
          keyword: {
            key: 1,
            value: null
          },
          keyword1: {
            key: 1,
            value: null
          },
          keyword2: {
            key: 1,
            value: null,
          },
          status: null,
          shipCountryCode: null,
          arrivalCountryCode: null,
          warehouseIds: null,
          transportId: null,
          marketIds: null,
        },
        option: {
          shipmentBillOption: shipmentBillOption,
          transportOption: [],
        },
        countryMap: transformToMap(countryOption),
        shipmentBillEnum: shipmentBillEnum,
        opBtnConfig: (row) => [
          {
            label: '详情',
            show: () => row.status !== this.shipmentBillEnum.ABOLISHED,
            click: () => this.openDetail(row)
          }, {
            label: '作废',
            show: () => row.status === this.shipmentBillEnum.WAIT_SHIPPED && this.$permission('shipNote:abolish'),
            click: () => this.abolished(row)
          }, {
            label: '标记完成',
            show: () => row.status === this.shipmentBillEnum.DELIVERYING && this.$permission('shipNote:finish'),
            click: () => this.markCompleted(row)
          }, {
            label: '日志',
            click: () => this.viewLog(row.id)
          },
        ],
        moduleName: 'SHIPMENT_BILL',
        model
      }
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : { key: params.dateType, value: [params.startDateTime, params.endDateTime]}
        this.filter = Object.assign({}, this.filter, {
          ...params,
          date
        })
      },
      loadViewComplete () {
        this.$emit('query')
      },
      $gjQuery() {
        this.loading = true;
        const params = {
          model: {
            status: this.filter.status,
            shipCountryCode: this.filter.shipCountryCode,
            arrivalCountryCode: this.filter.arrivalCountryCode,
            warehouseIds: this.filter.warehouseIds,
            transportId: this.filter.transportId,
            marketIds: this.filter.marketIds,
            code: this.filter.keyword.value,
            codeType: this.filter.keyword.key,
            keywordType: this.filter.keyword1.key,
            keyword: this.filter.keyword1.value,
            dateType: this.filter.keyword2.key,
            startDate: isMeaningful(this.filter.keyword2.value) ?
              convertToDate(this.filter.keyword2.value[0]) : null,
            endDate: isMeaningful(this.filter.keyword2.value) ?
              convertToDate(this.filter.keyword2.value[1]) : null,
          },
          ...this.querySort,
          ...this.queryPagination,
        };
        this.globalParams = params;
        getShipNotePage(params)
          .then((data) => {
            this.tableData = data.records.map((v, i) => {
              const noteItemList = this._.cloneDeep(v.noteItemList)
              return Object.assign(v, {
                productsCopy: noteItemList,
                noteItemList: noteItemList ? noteItemList.slice(0, 3) : [],
                expand: false,
                dataIndex: i
              })
            });
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            keyword: {
              key: 1,
              value: null
            },
            keyword1: {
              key: 1,
              value: null
            },
            keyword2: {
              key: 1,
              value: null,
            },
            status: null,
            shipCountryCode: null,
            arrivalCountryCode: null,
            warehouseIds: null,
            transportId: null,
            marketIds: null,
          },
        }
      },
      openDetail(row) {
        if (row.status === this.shipmentBillEnum.WAIT_SHIPPED) {
          const modal = this.$gjCreate(AppShipmentBillGenerate, {
            props: {
              item: row
            },
            on: {
              after: () => {
                modal.$gjDestroy();
                this.$gjResetPage();
              }
            }
          })
        } else {
          this.$gjCreate(AppShipmentBillDetail, {
            props: {
              item: row,
            },
            on: {
              after: () => {
                this.$gjResetPage();
              }
            }
          })
        }
      },
      // shipped(row) {
      //   const modal = this.$gjCreate('gj-info-modal', {
      //     props: {
      //       content: `确认出运？出运后供应商不可修改<br/>如果关联调拨单未出库，将自动变更其“已出库”！`,
      //     },
      //     on: {
      //       cancel: () => modal.$gjDestroy(),
      //       confirm() {
      //         modal.confirmLoading = true;
      //         setTimeout(() => modal.$gjDestroy(), 200)
      //       }
      //     }
      //   })
      // },
      markCompleted(row) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            content: `标记完成？<br/>该发货单标记后将不再更新收货量，状态更新为“已完成”！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm() {
              modal.confirmLoading = true;
              shipNoteFinish(row.id)
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    modal.$gjDestroy();
                  })
                }).complete(() => modal.confirmLoading = false)
            }
          }
        })
      },
      abolished(row) {
        const modal = this.$gjCreate('gj-textarea-modal', {
          props: {
            header: `作废<span class="modal-secondary-title">${row.code}</span>`,
            label: '作废理由',
            labelWidth: '75px',
            contentStyle: {padding: '16px 20px 0 20px'}
          },
          on: {
            submit: (reason) => {
              modal.confirmLoading = true;
              shipNoteAbolished({id: row.id, memo: reason})
                .then((res) => {
                  this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                  })
                }).complete(() => modal.confirmLoading = false)
            }
          }
        })
      },
      viewLog(id) {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: `/supply/shipNoteLog/logPage`,
            params: {
              model: {
                shipNoteId: id
              }
            },
            columns: [
              {id: 'op', header: '操作分类', field: 'option:op', minWidth: '120px', options: logOpType},
              {id: 'content', header: '操作内容', field: 'content', overflowLine: 2,  minWidth: '300px'},
              {id: 'opUser', header: '操作用户', field: 'createUserName', minWidth: '100px'},
              {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '130px'}
            ]
          },
          style: {
            'background': 'red'
          }
        })
      },
      openDetailRows(row, flag){
        if (flag) {
          row.noteItemList = row.productsCopy;
          row.expand = flag;
        } else {
          row.noteItemList = row.noteItemList.slice(0,3);
          row.expand = flag;
        }
        this.tableData = this.tableData.map(v => {
          if (v.id === row.id) {
            v.expand = row.expand
            v.noteItemList = row.noteItemList
          }
          return v
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
.iconfont{
  font-size: 10px;
  color: #999;
}
.iconshouqi{
  margin-left: 5px;
}
.label-color {
  color: #999;
}
.default {
  /deep/ .gj-link{
    &:hover{
      .iconfont{
        color: #1F6EEF;
      }
    }
  }
}
</style>
